import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fabric Imports
import { useNavigate } from "react-router-dom";
import {
  Button,
  Field,
  Image,
  Input,
  Link,
  MessageBar,
  MessageBarActions,
  Text,
} from "@fluentui/react-components";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import {
  ArrowClockwiseRegular,
  ArrowRightRegular,
  PersonKeyRegular,
} from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";

const CheckValidToken = (value: string): string => {
  // TODO: Token Validierung
  return "";
};

const CheckValidUserId = (value: string): string => {
  // TODO: User Validierung
  return "";
};

function ConfirmEmail(props: any) {
  const navigate = useNavigate();
  const [verifyModel, setVerifyModel] = useState({ userId: "", token: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [verificationSent, setVerificationSent] = useState(false);
  const [eMailVerified, setEMailVerified] = useState(false);

  const FormValidation = (): void => {
    if (
      CheckValidToken(verifyModel.token) &&
      CheckValidUserId(verifyModel.userId)
    ) {
      SubmitToken(verifyModel);
    }
  };

  const SubmitToken = (model: {}): void => {
    fetchWrapper
      .post(`${baseUrl}/api/account/confirmemail`, model)
      .then((result) => {
        if (result.message == "EMAIL_CONFIRMED") {
          setEMailVerified(true);
          //window.location.replace(baseUrl + "/account/login");
        } else if (result.message == "EMAIL_NOT_CONFIRMED") {
          setErrorMessage(result.message);
        } else {
          setErrorMessage(i18n.t<string>("tokenInvalid"));
        }
      })
      .catch((error) => {
        setErrorMessage(i18n.t<string>("tokenInvalid"));
      });
  };

  useEffect(() => {
    const id = window.location?.search?.substring(
      window.location?.search?.indexOf("userId=") + 7,
      window.location?.search?.indexOf("&token="),
    );
    const token = window.location?.search?.substring(
      window.location?.search?.indexOf("&token=") + 7,
    );
    setVerifyModel({ userId: id!, token: token! });
    if (token && id) {
      SubmitToken({ userId: id!, token: token! });
    }
  }, []);

  const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
    window.navigator.userAgent,
  );

  const resendVerificationEmail = () => {
    fetchWrapper
      .get(
        `${baseUrl}/api/account/ResendVerificationMail?email=${verifyModel.userId}`,
      )
      .then(() => {
        setVerificationSent(true);
        setErrorMessage("");
      });
  };

  const windowSize = useWindowSize();

  return (
    <div>
      <div
        className={
          isIEOrEdge
            ? "blockContainerContentCenteredIe"
            : "blockContainerContentCentered"
        }
      >
        <div
          style={{
            borderRadius: "11px",
            backgroundColor: "white",
            boxShadow: "0px 6px 12px 5px silver",
            minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
            maxWidth: 500,
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: 20,
            marginBottom: 20,
            animationDuration: "4s",
          }}
        >
          <div style={{ padding: 20 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                marginBottom: "20px",
              }}
            >
              <Link
                onClick={() => {
                  navigate("/");
                }}
              >
                <Image
                  alt=""
                  src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                  height={50}
                />
              </Link>
            </div>
            {!eMailVerified && (
              <div className="lueb-padding5 lueb-MarginTopBottom10">
                <form
                  onSubmit={(e: any) => {
                    e.preventDefault();
                    FormValidation();
                  }}
                >
                  <h3 className="lueb-MarginTopBottom10">
                    {i18n.t<string>("verifyEmail")}
                  </h3>
                  <div className="lueb-MarginTopBottom10">
                    <Text>{i18n.t<string>("enterToken")}</Text>
                  </div>
                  <Field label={"E-Mail"} style={{ marginTop: "5px" }}>
                    <Input
                      /* onGetErrorMessage={CheckValidUserId} */
                      /* className="lueb-MarginBottom20" */
                      appearance="underline"
                      value={verifyModel.userId}
                      placeholder="E-Mail"
                      onChange={(ev, data) => {
                        verifyModel.userId = data.value;
                        setVerifyModel({
                          userId: data.value,
                          token: verifyModel.token,
                        });
                      }}
                    />
                  </Field>
                  <Field
                    label={i18n.t<string>("verifyToken")}
                    style={{ marginTop: "5px" }}
                  >
                    <Input
                      /* onGetErrorMessage={CheckValidToken}
                      className="lueb-MarginBottom20" */
                      appearance="underline"
                      value={verifyModel.token}
                      placeholder={i18n.t<string>("verifyToken")}
                      onChange={(ev, data) => {
                        verifyModel.token = data.value;
                        setVerifyModel({
                          userId: verifyModel.userId,
                          token: data.value,
                        });
                      }}
                    />
                  </Field>
                  {errorMessage != "" && (
                    <MessageBar intent={"error"}>
                      <MessageBarActions>
                        <Button
                          icon={<ArrowClockwiseRegular />}
                          appearance="transparent"
                          onClick={() => {
                            resendVerificationEmail();
                          }}
                        >
                          {i18n.t<string>("resendVerificationEmail")}
                        </Button>
                      </MessageBarActions>
                      {i18n.t<string>(errorMessage)}
                    </MessageBar>
                  )}
                  {verificationSent == true && (
                    <MessageBar intent={"success"}>
                      {i18n.t<string>("verificationWasSent")}
                    </MessageBar>
                  )}
                  <div
                    style={{
                      padding: 5,
                      marginBottom: 10,
                      marginTop: 10,
                      float: "right",
                    }}
                  >
                    <Button
                      appearance="primary"
                      icon={<ArrowRightRegular />}
                      iconPosition="after"
                      onClick={() => FormValidation()}
                      disabled={
                        verifyModel.token == "" && verifyModel.userId == ""
                      }
                    >
                      {i18n.t<string>("next")}
                    </Button>
                  </div>
                </form>
              </div>
            )}

            {eMailVerified && (
              <div className="lueb-padding5 lueb-MarginTopBottom10">
                <StackShim horizontal>
                  <h3>{i18n.t<string>("eMailVerified")}</h3>
                </StackShim>
                <div className="lueb-MarginTopBottom10">
                  {i18n
                    .t("eMailVerifiedText")
                    .split("\n")
                    .map((item) => {
                      return (
                        <div className="lueb-MarginTopBottom10">
                          <Text>{item}</Text>
                        </div>
                      );
                    })}
                </div>
                <Button
                  icon={<PersonKeyRegular />}
                  onClick={() => navigate("/account/login")}
                >
                  {i18n.t<string>("goToLogin")}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmEmail;
